<template>
  <div class="pt-16 pb-32 container-base">
    <q-card v-show="!loading.tabs">
      <OTabs
        v-model="tab"
        :tabs="tabs"
        :loading="false"
        class="w-max"
      />

      <q-tab-panels v-model="tab" animated>
        <template v-for="categoria in tabs" :key="categoria.id">
          <q-tab-panel :name="categoria.name">
            <section class="px-24 pt-16 pb-56">
              <header class="pt-8 flex justify-between">
                <p class="text-title-3">{{ categoria.label }}</p>
                <OSelect
                  v-model="modelSelect"
                  disable
                  :options="options"
                  size="md"
                  class="w-[337px]"
                >
                </OSelect>
              </header>

              <div class="pt-16 flex gap-24">
                <template v-if="!loading.materiais">
                  <template
                    v-for="material in materials"
                    :key="material.id"
                  >
                    <q-card
                      v-if="
                        material.tipo_material?.id === categoria.name
                      "
                      class="w-[330px] h-[132px]"
                    >
                      <div
                        class="w-full h-[40px] bg-neutral-5 relative"
                      >
                        <div
                          class="absolute left-20 top-20 w-[36px] h-[36px] bg-white"
                        >
                          <q-icon
                            name="svguse:#icon_pdf"
                            class="w-[24px] h-[24px] icone"
                          />
                        </div>
                      </div>

                      <div
                        class="pt-20 pl-16 flex flex-nowrap justify-between"
                      >
                        <div class="text-pararaphy-2">
                          <p :title="material.nome" class="two-lines">
                            {{ material.nome }}
                          </p>
                          <p class="text-neutral-70 pt-2">120kb</p>
                        </div>

                        <q-btn-dropdown
                          class="w-[36px] h-[36px] shrink-0 mr-16 mt-16 rounded-full border-solid border border-neutral-10"
                          size="sm"
                          no-icon-animation
                          menu-anchor="bottom middle"
                          menu-self="top left"
                          dropdown-icon="more_vert"
                        >
                          <div class="w-[380px] p-16 rounded-md">
                            <div
                              class="flex justify-between align-middle"
                            >
                              <div
                                class="w-[36px] h-[36px] border-solid border border-neutral-10"
                              >
                                <q-icon
                                  name="svguse:#icon_pdf"
                                  class="w-[24px] h-[24px] icone"
                                />
                              </div>
                              <p class="text-neutral-70">
                                {{
                                  FDataAndTime(material.data_criacao)
                                }}
                              </p>
                            </div>

                            <div class="flex">
                              <p class="pt-12 pb-12">
                                <b>{{ material.detalhes.name }}</b>
                              </p>
                              <p class="pb-6">
                                {{ material.descricao }}
                              </p>
                              <OButton
                                class="p-16 w-full bg-primary-pure rounded-md"
                                :label="t('download')"
                                color=""
                                @click="goToFile(material)"
                              />
                            </div>
                          </div>
                        </q-btn-dropdown>
                      </div>
                    </q-card>
                  </template>
                  <EmptyItem
                    v-if="
                      materials.filter(
                        (m) => m.tipo_material?.id === categoria.name
                      )?.length === 0
                    "
                    :text="t('notFound')"
                  />
                </template>
                <BaseLoader
                  v-else
                  class="min-h-[135px] grid place-items-center w-full"
                />
              </div>
            </section>
          </q-tab-panel>
        </template>
      </q-tab-panels>
    </q-card>
    <BaseLoader
      v-show="loading.tabs"
      class="min-h-[300px] grid place-items-center w-full"
    />
  </div>
</template>

<script setup>
import { date } from 'quasar'
import { materiaisService } from 'js/vue/services/materiais.service'
import { onMounted, ref } from 'vue'
import { tiposMateriaisService } from 'js/vue/services/tiposMateriais.service'
import { useI18n } from 'vue-i18n'
import BaseLoader from 'components/Loader/BaseLoader.vue'
import EmptyItem from 'components/Empty/EmptyItem.vue'
import GLOBAL from 'js/utils/GLOBAL'
import OButton from 'components/Button/OButton.vue'
import OSelect from 'components/Select/OSelect.vue'
import OTabs from 'components/Tabs/OTabs.vue'

const { t } = useI18n()
const { getMateriais } = materiaisService()
const { getTiposMateriais } = tiposMateriaisService()

const materials = ref([])

const tab = ref('')
const tabs = ref([])

const modelSelect = ref('')
const options = ref([])
const { blobDownloadFile, FDataAndTime } = GLOBAL

const goToFile = (material) => {
  blobDownloadFile(material.material, material.detalhes.name)
}

const loading = ref({
  tabs: true,
  materiais: true,
})
onMounted(async () => {
  const _tabs = await getTiposMateriais()

  tabs.value = _tabs.results.map(({ nome, id }) => ({
    name: id,
    label: nome,
  }))

  tab.value = tabs.value.at().name
  loading.value.tabs = false

  const { results } = await getMateriais()
  materials.value = results
  loading.value.materiais = false
})
</script>

<style lang="scss" scoped>
.icone {
  padding: 5px;
}

.botao {
  border: 1px solid lightgrey;
}
</style>
